module.exports = __webpack_public_path__ + "img/symbol_0.63d64697.png";